import React from 'react';
import { Link } from 'react-router-dom';

const SECTIONS = [
  {
    title: '1. What we collect',
    body: `Account info (name, email address, and a profile photo if you sign in with Google); gameplay data (levels completed, scores, chain counts, and reward balances such as Gold Coins, Quantum Shards, Galaxy Keys, Research Points, and Time Pods); and basic device/usage data (app version, device type, crash logs) to keep the game running smoothly.`,
  },
  {
    title: '2. How we use it',
    body: `To sync your progress and rewards across devices, authenticate your account, show your name in the app, respond to support requests, and improve level design and app stability based on aggregated, non-identifying gameplay trends.`,
  },
  {
    title: '3. Authentication',
    body: `Sign-in is handled by Firebase Authentication (Google/Firebase, a service of Google LLC). If you sign in with Google, we receive your name, email, and profile photo as provided by Google — we never see or store your password.`,
  },
  {
    title: '4. Where data is stored',
    body: `Account and reward data is stored in Cloud Firestore (Google Cloud). If you play without an account, your progress is stored only locally on your device and is not synced anywhere.`,
  },
  {
    title: '5. Sharing',
    body: `We do not sell your personal data. We share data only with service providers that operate the app on our behalf (Firebase/Google Cloud for authentication and storage, and ad networks if you choose to watch a rewarded ad), or when required by law.`,
  },
  {
    title: '6. Children’s privacy',
    body: `CascadeJoy is not directed at children under 13, and we do not knowingly collect personal information from them. If you believe a child has provided us personal data, contact us via Support and we will remove it.`,
  },
  {
    title: '7. Your choices',
    body: `You can edit your display name from your Profile page, sign out at any time, or request deletion of your account and associated data via the Support page. Uninstalling the app removes any progress that was never synced to an account.`,
  },
  {
    title: '8. Data retention',
    body: `We retain account and reward data for as long as your account is active, or as needed to provide the service. Deleted accounts are removed within a reasonable time after your request.`,
  },
  {
    title: '9. Security',
    body: `We use industry-standard practices (including Firebase's built-in security rules and encryption in transit) to protect your data, but no method of transmission or storage is 100% secure.`,
  },
  {
    title: '10. Changes to this policy',
    body: `We may update this Privacy Policy from time to time. We'll update the "Last updated" date above when we do.`,
  },
  {
    title: '11. Contact',
    body: `Questions about your data or this policy? Reach out via the Support page.`,
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Legal</span>
        <h1 className="page-title section-gap">Privacy Policy</h1>
        <p className="page-subtitle">Last updated: August 8, 2026 · Applies to CascadeJoy on web, Android, and iOS.</p>

        <div className="mt-8 space-y-6">
          {SECTIONS.map((s) => (
            <section key={s.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
              <h2 className="text-base font-black text-slate-900">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
